import { formatDistanceToNow, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export const itemSerialize = ({
  isFavorite,
  lastUpdate,
  updatedAt,
  isFeatured,
  contentBody,
  ...dataItem
}) => ({
  ...dataItem,
  contentBody,
  isFeatured,
  isFavorite,
  lastUpdate,
  lastUpdateFormatted:
    lastUpdate &&
    formatDistanceToNow(parseISO(lastUpdate), {
      addSuffix: true,
      locale: ptBR
    }),
  updatedAt,
  updateFormatted:
    updatedAt &&
    formatDistanceToNow(parseISO(updatedAt), {
      addSuffix: true,
      locale: ptBR
    })
})

export const getKnowledgeBasesSerialize = ({
  data,
  metadata: {
    pagination: { currentPage, lastPage, total }
  }
}) => {
  return {
    data: data.map(itemSerialize),
    pagination: {
      currentPage,
      lastPage,
      total
    }
  }
}

export const getCategoriesSerialize = ({ data }) => {
  return {
    data
  }
}
